import React from 'react'
import { Helmet } from '@dr.pogodin/react-helmet'
import { Card as MuiCard, CardContent, Divider, LinearProgress, Typography } from '@mui/material'
import styled from '@emotion/styled'
import { spacing } from '@mui/system'
import { useTranslation } from 'react-i18next'
import useAuth from '../../../hooks/useAuth'
import InvestorApi from '../../../api/InvestorApi'
import InvestorsGrid from './InvestorsGrid'
import { InvestorWithAliases } from '@finance-lab/utils/types'

const Card = styled(MuiCard)(spacing)

function InvestorsView() {
    const { t } = useTranslation()
    const { isAuthenticated } = useAuth()

    const [investors, setInvestors] = React.useState<Array<InvestorWithAliases> | null>(null)

    React.useEffect(() => {
        async function fetchInvestors() {
            if (!isAuthenticated) return
            const api = new InvestorApi()
            const response = await api.allInvestors()
            setInvestors(response)
        }
        fetchInvestors()
    }, [isAuthenticated])

    return (
        <React.Fragment>
            <Helmet title={t('entities.investor.plural')} />
            <Typography
                variant='h3'
                gutterBottom
                sx={{
                    display: 'block',
                }}
            >
                {t('entities.investor.plural')}
            </Typography>
            <Divider />
            <Card mb={6}>
                <CardContent>
                    {!investors && <LinearProgress />}
                    {investors && <InvestorsGrid investors={investors} setInvestors={setInvestors} />}
                </CardContent>
            </Card>
        </React.Fragment>
    )
}

export default InvestorsView
